export default "__VITE_ASSET__BNWlhhgN__"